













import Vue from 'vue';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
    VbTooltipSlot,
  },
})
export default class ContractItemAutomationButton extends Vue {
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean

  private click(): void {
    this.$emit('click');
  }
}
